module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('div', {
    staticClass: "ui-toast"
  }, [_c('div', {
    ref: "content",
    staticClass: "toastwrap text",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eb5e254"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/notice.vue
// module id = 463
// module chunks = 9